import template from 'url-template';

import { get } from 'lodash';

import moment from 'moment';

import { setBobLoading } from './bobActions';

import {
    FETCH_SERVICE_REQUEST_LIST,
    FETCH_JOB_ISSUE_TYPES,
    FETCH_JOB_SKILL_TYPES,
    FETCH_JOB_SKILL_LEVEL
} from './actionTypes';

import awsHeader from '../helpers/awsAuth';
import k2aBaseApi from '../apis/key2act';

import { handleNetworkError, enqueueSnackbar } from './applicationMessageActions';
import { setProgressBarLoading } from './coreActions';
import { setDashboardCurrentTimestamp } from './dashboardActions';

const ServiceCalls = template.parse('/companies/{companyId}/jobs{?searchFilter,sort,page,limit}');
const ServiceManagementlookup = template.parse('/companies/{companyId}/lookups{?type}');
const CreateServiceCall = template.parse('/companies/{companyId}/jobs');

const DEFAULT_PAGE_LIMIT = 20;
const DEFAULT_SORT = '';

export const fetchServiceRequestList = (companyId, options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();
    
    options.limit || (options.limit = DEFAULT_PAGE_LIMIT);
    options.page || (options.page = 1);
    options.searchFilter || (options.searchFilter = '');
    options.sort || (options.sort = DEFAULT_SORT);

    dispatch(setBobLoading('ServiceRequestData'));

    try {
        const response = await k2aBaseApi.get(
            ServiceCalls.expand({
                companyId,
                ...options
            }),
            header
        );

        const data = get(response, 'data.data', []);
        const meta = get(response, 'data.meta', {});
        
        dispatch({
            type:    FETCH_SERVICE_REQUEST_LIST,
            payload: {
                data,
                meta
            }
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    } finally {
        dispatch(setDashboardCurrentTimestamp(moment().local()));
        dispatch(setBobLoading('ServiceRequestData'));
        dispatch(setProgressBarLoading(false));
    }
};

export const fetchServiceManagementLookups = (companyId, type,  options = {}) => async (dispatch, getState) => {
    const header = await awsHeader();
    dispatch(setBobLoading(type));

    try {
        const response = await k2aBaseApi.get(
            ServiceManagementlookup.expand({
                companyId,
                type
            }),
            header
        );
        
        const data = get(response, 'data.data', []);
        
        switch (type) {
            case 'Jobissuetype':

                dispatch({
                    type:    FETCH_JOB_ISSUE_TYPES,
                    payload: {
                        data
                    }
                });
                break;
            case 'Skilltype':
    
                dispatch({
                    type:    FETCH_JOB_SKILL_TYPES,
                    payload: {
                        data
                    }
                });
                break;
            case 'Skilllevel':

                dispatch({
                    type:    FETCH_JOB_SKILL_LEVEL,
                    payload: {
                        data
                    }
                });
                break;
            default:
                break;
        }

    } catch (error) {
        dispatch(handleNetworkError(error));
    } finally {
        dispatch(setBobLoading(type));
        dispatch(setProgressBarLoading(false));
    }
};

export const createServiceCall = (companyId, body) => async (dispatch, getState) => {
    const header = await awsHeader();

    try {
        const response = await k2aBaseApi.post(
            CreateServiceCall.expand({
                companyId
            }),
            body,
            header
        );
        
        dispatch(enqueueSnackbar('Service call created successfully', 'success'));
        
        return get(response, 'data.id', true);

    } catch (error) {
        dispatch(handleNetworkError(error));

        return false;
    } finally {
        dispatch(setProgressBarLoading(false));
    }

};

export const updateServiceCall = (companyId, body) => async (dispatch, getState) => {
    const header = await awsHeader();

    try {
        const response = await k2aBaseApi.put(
            CreateServiceCall.expand({
                companyId
            }),
            body,
            header
        );
        
        dispatch(enqueueSnackbar('Service call updated successfully', 'success'));
        
        return get(response, 'data.id', true);

    } catch (error) {
        dispatch(handleNetworkError(error));

        return false;
    } finally {
        dispatch(setProgressBarLoading(false));
    }
};
